export default __webpack_public_path__ + "static/media/xswap-logo.2dabffac.png";